<template>
	<div class="organization-config-wrap">
		<Tabs type="card">
			<TabPane label="公众号配置">
				<wx-config></wx-config>
			</TabPane>
			<TabPane label="系统配置">
				<system-config></system-config>
			</TabPane>
			<TabPane label="模板消息配置">
				<wxTemplateConfig></wxTemplateConfig>
			</TabPane>
      <TabPane label="水印配置">
				<water-mark></water-mark>
			</TabPane>
		</Tabs>
	</div>
</template>

<script>
	import WxConfig from './components/wx-config'
	import SystemConfig from './components/system-config'
	import wxTemplateConfig from './components/wx-template-config'
  import waterMark from './components/watermark.vue'
	export default {
		name: 'organizationConfig',
		components: {
			WxConfig,
			SystemConfig,
			wxTemplateConfig,
      waterMark
		},
		data() {
			return {
				// query参数
				query: {},
				// 搜索
				search: {},
				// DOM操作
				diyDom: {},
				// 自定义数据
				diyData: {},
				// 接口数据
				apiData: {},
			}
		},
		methods: {},
		mounted() {},
	}
</script>

<style scoped lang="less">
	.organization-config-wrap {
	}
</style>
